import { render } from "./SurveyTodo.component.vue?vue&type=template&id=058afe4a"
import script from "./SurveyTodo.component.vue?vue&type=script&lang=js"
export * from "./SurveyTodo.component.vue?vue&type=script&lang=js"

import "./SurveyTodo.component.vue?vue&type=style&index=0&id=058afe4a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__